<script setup>
import { DateInput, DmButton, DmCountrySelect, DmIndustrySelect, MultiSelectDropdown } from 'dmui_components'
import { computed } from 'vue'
import ExpectedReportRepository from '../repository/ExpectedReportRepository.js'

const props = defineProps({
	filters: {
		type: Object,
		default: () => ({})
	},
	readonly: {
		type: Boolean,
		default: false
	}
})
const emit = defineEmits(['update:filters', 'reset:filters'])
const typeFilterOptions = ExpectedReportRepository.reportTypes
const yearFilterOptions = ExpectedReportRepository.years
const fiscalMonthFilterOptions = ExpectedReportRepository.fiscalMonths
const marketBucketFilterOptions = ExpectedReportRepository.marketBuckets
const vueDatePickerProps = {
	yearRange: [new Date().getFullYear() - 2, new Date().getFullYear() + 1]
}

function onUpdateFilter(key, value) {
	if (key === 'fiscal_month') {
		emit('update:filters', { ...props.filters, [key]: value.map((month) => fiscalMonthFilterOptions.indexOf(month) + 1) })
	} else {
		emit('update:filters', { ...props.filters, [key]: value })
	}
}

const filtersApplied = computed(() => Object.values(props.filters).flat().length > 0)
</script>
<template>
	<div class="filters-header">
		<MultiSelectDropdown id="document-type" :selected="filters.document_type" :options="typeFilterOptions" label="Type" @update:selected="onUpdateFilter('document_type', $event)">
			<template #option="{ option }">{{ option?.charAt(0).toUpperCase() + option?.slice(1) }}</template>
		</MultiSelectDropdown>
		<MultiSelectDropdown id="document-year" :selected="filters.document_year" :options="yearFilterOptions" label="Year" @update:selected="onUpdateFilter('document_year', $event)">
			<template #option="{ option }">{{ option }}</template>
		</MultiSelectDropdown>
		<DmCountrySelect
			id="document-country"
			:data="filters.country_name"
			:show-preview="false"
			placeholder="Country & region"
			@update:data="onUpdateFilter('country_name', $event)" />
		<DmIndustrySelect id="document-industry" :data="filters.industry_name" :show-preview="false" placeholder="Sector" @update:data="onUpdateFilter('industry_name', $event)" />
		<MultiSelectDropdown
			id="fiscal-month"
			:selected="filters.fiscal_month.map((month) => fiscalMonthFilterOptions[month - 1])"
			:options="fiscalMonthFilterOptions"
			label="Fiscal month"
			@update:selected="onUpdateFilter('fiscal_month', $event)">
			<template #option="{ option }">{{ option }}</template>
		</MultiSelectDropdown>
		<MultiSelectDropdown
			id="market-bucket"
			:selected="filters.market_bucket"
			:options="marketBucketFilterOptions"
			label="Market bucket"
			@update:selected="onUpdateFilter('market_bucket', $event)">
			<template #option="{ option }">{{ option }}</template>
		</MultiSelectDropdown>
		<DateInput
			id="expected-date-upto"
			:data="filters.expected_date"
			:show-icon="true"
			placeholder="Expected date up to"
			:vue-date-picker-props="vueDatePickerProps"
			@update:data="onUpdateFilter('expected_date', $event)" />
		<DmButton v-if="filtersApplied" id="clear-filters" class="transparent small" @click="$emit('reset:filters')">Clear all</DmButton>
		<DmButton v-if="!readonly" id="add-report" class="small" @click="$router.push('report/edit?source=Expected')">Add new</DmButton>
	</div>
</template>

<style scoped lang="less">
.filters-header {
	display: flex;
	gap: @micro;
	align-items: center;
	margin-bottom: @midi;
	#add-report {
		margin-left: auto;
	}
}

:deep(.dp__input) {
	padding-left: 35px;
}
:deep(.dp__main) {
	width: fit-content;
}
</style>
